import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import Settings from './Settings';
import Auth from './Auth';
import Profile from './Profile';
import Statistics from './Statistics';
import Reports from './Reports';
import AccountSettings from './AccountSettings';
import SystemSettings from './SystemSettings';
import Notifications from './Notifications';
import NewReport from './NewReport';
import GeneralSearch from './GeneralSearch';
import Content from './Content';
import AdminResponsibilities from './AdminResponsibilities';
import MeldooWeb from './MeldooWeb';
import News from './News';
import Intro from './Intro';
import adminFeedback from './AdminFeedback';
import mailResponse from './MailResponse';
import newIssue from './NewIssue';

const reducers = combineReducers({
	routing: routerReducer,
	settings: Settings,
	auth: Auth,
	profile: Profile,
	statistics: Statistics,
	reports: Reports,
	accountSettings: AccountSettings,
	systemSettings: SystemSettings,
	notifications: Notifications,
	newReport: NewReport,
	generalSearch: GeneralSearch,
	content: Content,
	adminResponsibilities: AdminResponsibilities,
	meldooWeb: MeldooWeb,
	news: News,
	intro: Intro,
	adminFeedback,
	mailResponse,
	newIssue
});

export default reducers;



// WEBPACK FOOTER //
// ./reducers/index.js